var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "container-item-wrapper",
    { attrs: { widget: _vm.widget } },
    [
      _c(
        "el-row",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.widget.options.hidden,
              expression: "!widget.options.hidden",
            },
          ],
          key: _vm.widget.id,
          ref: _vm.widget.id,
          staticClass: "grid-container",
          class: [_vm.customClass],
          attrs: { gutter: Number(_vm.widget.options.gutter) || 0 },
        },
        [
          _vm._l(_vm.widget.cols, function (colWidget, colIdx) {
            return [
              _c("grid-col-item", {
                key: colIdx,
                attrs: {
                  widget: colWidget,
                  "parent-list": _vm.widget.cols,
                  "index-of-parent-list": colIdx,
                  "parent-widget": _vm.widget,
                  "col-height": _vm.widget.options.colHeight,
                },
                scopedSlots: _vm._u(
                  [
                    _vm._l(Object.keys(_vm.$scopedSlots), function (slot) {
                      return {
                        key: slot,
                        fn: function (scope) {
                          return [_vm._t(slot, null, null, scope)]
                        },
                      }
                    }),
                  ],
                  null,
                  true
                ),
              }),
            ]
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }